import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../../styles/Sidebar.css';

const Sidebar = ({ isOpen, onClose, menuItems }) => {
  const location = useLocation();

  const getIconClass = (icon) => {
    const iconMap = {
      home: 'fas fa-home',
      briefcase: 'fas fa-briefcase',
      users: 'fas fa-users',
      clock: 'fas fa-clock',
      'bar-chart': 'fas fa-chart-bar',
      'message-square': 'fas fa-envelope',
      'check-square': 'fas fa-check-square',
      calendar: 'fas fa-calendar',
      settings: 'fas fa-cog'
    };
    return iconMap[icon] || 'fas fa-circle';
  };

  const isActive = (path) => {
    if (path === '/dashboard') {
      return location.pathname === '/dashboard';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div className="sidebar-overlay" onClick={onClose}></div>
      )}

      <aside className={`sidebar ${isOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <i className="fas fa-building"></i>
            <span className="sidebar-brand">Versai Tech Solutions
            </span>
          </div>
          <button className="sidebar-close" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <nav className="sidebar-nav">
          <ul className="sidebar-menu">
            {menuItems.map((item, index) => (
              <li key={index} className="sidebar-item">
                <Link
                  to={item.path}
                  className={`sidebar-link ${isActive(item.path) ? 'active' : ''}`}
                  onClick={onClose}
                >
                  <i className={getIconClass(item.icon)}></i>
                  <span className="sidebar-text">{item.name}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
